import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';

function normalizeMenuPath(path: string) {
  const normalizedPath = getSafeHref(path).replace(/\/+$/, '');

  return normalizedPath || '/';
}

export function isServicesMenuItem(path?: string) {
  return normalizeMenuPath(path ?? '') === normalizeMenuPath(ROUTES.SERVICES());
}
